export const WATER_LEVEL = 0;
export const GROUND_LEVEL = 10;
export const GROUND_WIDTH = 320;
export const PLAYER_WIDTH = 16;
export const PLAYER_HEIGHT = 24;
export const PLAYER_MOVEMENT_SPEED = 220;
export const PLAYER_JUMP_SPEED = 600;
export const GRAVITY = 2400;
export const PLAYER_PROJECTILE_SPEED = 40;
export const ENEMY_PROJECTILE_SPEED = 4;
export const ENEMY_SPAWN_INTERVAL = 1;
export const ENEMY_RADIUS = 25;
export const ENEMY_SPEED = 140;
export const PLAYER_INITIAL_HEALTH = 100;
export const HEALTH_POWER_UP_AMOUNT = 25;
export const HEALTH_POWER_UP_RADIUS = 30;
export const ENEMY_INITIAL_HEALTH = 30;
export const PROJECTILE_RADIUS = 5;
export const PLAYER_PROJECTILE_DAMAGE = 30;
export const ENEMY_PROJECTILE_DAMAGE = 10;
export const ENEMY_FIRING_INTERVAL = 7.2; // make enemies shoot every n seconds
export const WRECK_FALL_DELAY = 0.2;
export const GRID_LEFT = -160;
export const GRID_RIGHT = 160;
export const GRID_TOP = 450;
export const GRID_BOTTOM = GROUND_LEVEL - 5;
export const GRID_COLUMNS = 8;
export const GRID_ROWS = 12;
export const POWER_UP_SPAWN_START_Y = 300;
export const POWER_UP_SPAWN_DISTANCE = 400; // spawn power-ups every n pixels
export const PLAYER_ID = "player";
export const PRECISION = 0.0001;
export const SCORE_PER_ENEMY = 1;
